import { FC } from 'react';
import { Modal } from 'antd';
import { ISpeakingRubricItemScale } from '../../../../models/newSpeaking.model';
import styled from 'styled-components';
import { AiOutlineCheck } from 'react-icons/ai';

interface IProps {
  color?: string;
  visible: boolean;
  data: ISpeakingRubricItemScale[];

  onCancel(): void;
}

const Arrow = styled.img`
  max-height: 100%;
`;

const GuideModal: FC<IProps> = ({ color, visible, data, onCancel }) => {
  const getUrl = () => {
    switch (color) {
      case '#ffc000':
        return '/images/yellowArrow.png';
      case '#ff0000':
        return '/images/redArrow.png';
      case '#92d050':
      default:
        return '/images/greenArrow.png';
    }
  };

  return (
    <Modal
      title="Evaluation Guide"
      visible={visible}
      onCancel={onCancel}
      footer={[]}
    >
      <div className="d-flex flex-grow-0 flex-shrink-0">
        <div className="d-flex flex-column align-items-center mr-5">
          <p style={{ color }}>Excellent</p>
          <Arrow src={getUrl()} />
          <p style={{ color }}>Poor</p>
        </div>
        <div className="d-flex flex-column justify-content-center">
          {data.map(({ descriptionEng, descriptionKor }, index) => (
            <div className="mb-3" key={index}>
              <div className="d-flex align-items-start">
                <AiOutlineCheck className="mr-2" size={18} />
                <p className="mb-0">{descriptionEng}</p>
              </div>
              <div className="d-flex">
                <AiOutlineCheck
                  className="mr-2"
                  style={{ visibility: 'hidden' }}
                />
                <p className="mb-0" style={{ color: '#cccccc' }}>
                  {descriptionKor}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default GuideModal;
